/**
 * Figma CTA Component
 * Handles "Launch in Figma" / "Open in Figma" buttons with Figma icon prefix
 * and automatic install intent tracking
 */

import React from 'react';
import FigmaIcon from '@/assets/graphics/icons/figma';
import { trackInstallIntent } from '@/utils/trackInstallIntent';

interface FigmaCTAProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  location: 'header' | 'hero' | 'features' | 'pricing' | 'footer' | 'final-cta';
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  showIcon?: boolean;
}

export const FigmaCTA: React.FC<FigmaCTAProps> = ({
  href,
  children,
  className,
  location,
  onClick,
  showIcon = true,
}) => {
  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    const isFigmaLink = href.includes('figma.com/community/plugin');
    
    if (isFigmaLink) {
      await trackInstallIntent(location, href);
    }
    
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <a
      href={href}
      className={className}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
    >
      {showIcon && <FigmaIcon size={24} />}
      {children}
    </a>
  );
};

